import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import moment from 'moment';

import './styles.scss';

import Header from 'components/organisms/header/index.jsx';
import Button from 'components/atoms/button';
import FormContent from 'components/organisms/formContent';
import FormActions from 'components/molecules/formActions';
import FormHeader from 'components/molecules/formHeader';
import FormCol from 'components/molecules/formCol';
import CalendarMonthNavigation from 'components/molecules/calendarMonthNavigation/index.jsx';
import FormCalendar from 'components/organisms/formCalendar/index.jsx';
import FormCalendarCardSelect from 'components/molecules/formCalendarCardSelect/index.jsx';
import Loader from 'components/atoms/loader';
import WizardProgress from 'components/organisms/wizard/progress';
import { fetchCalendar } from 'actions/models';
import { buildRequestObject } from 'helpers/vehicle';
import validate from '../validate';

class ShiftSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      baseDate: moment().format('YYYY-MM-DD'),
    };
  }

  componentDidMount() {
    this.update();
  }

  update() {
    const { vehicle, engine, transmission, traction, services, date, workshop } = this.props;

    const attributes = buildRequestObject({
      workshop,
      vehicle,
      engine,
      transmission,
      traction,
      services,
      date,
    });

    attributes.from = this.getStartDate();
    attributes.to = this.getEndDate();

    this.props.fetchCalendar(attributes, this.props.brandId);
  }

  getStartDate() {
    const start = moment(this.state.baseDate);

    if (start.isSame(moment(), 'day')) {
      start.add(2, 'd');
    }

    return start.format('YYYY-MM-DD');
  }

  getEndDate() {
    return moment(this.getStartDate())
      .endOf('month')
      .format('YYYY-MM-DD');
  }

  componentDidUpdate() {
    if (!this.props.calendar?.length) {
      return;
    }
    if (this.state.baseDate !== this.props.calendar[0].date) {
      this.setState({
        baseDate: this.props.calendar[0].date
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.baseDate != this.state.baseDate) {
      this.state.baseDate = nextState.baseDate;

      this.update();

      return false;
    }

    return true;
  }
  render() {
    const { handleSubmit, calendar, date } = this.props;

    const currentMonth = moment(this.state.baseDate).format('MMMM YYYY');

    return (
      <div className="shiftSelect">
        <Header inFlow />
        <WizardProgress step="3" />
        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Agenda tu turno</h2>
              <p className="m">Elegí el día más conveniente para tu turno de taller.</p>
              <FormContent nomargins>
                <form onSubmit={handleSubmit}>
                  <FormHeader>
                    <CalendarMonthNavigation
                      currentMonth={currentMonth}
                      prev={() => {
                        let newDate = moment(this.state.baseDate)
                          .subtract(1, 'M')
                          .startOf('month');

                        if (newDate < moment()) {
                          newDate = moment().add(5, 'd');
                        }

                        this.setState({
                          baseDate: newDate.format('YYYY-MM-DD'),
                        });
                      }}
                      next={() => {
                        const newDate = moment(this.state.baseDate)
                          .add(1, 'M')
                          .startOf('month')
                          .format('YYYY-MM-DD');

                        this.setState({
                          baseDate: newDate,
                        });
                      }}
                      navigable
                    />
                  </FormHeader>
                  <FormCol single scrolleable>
                    <FormCalendar>
                      {this.props.isFetching && <Loader />}
                      {!this.props.isFetching &&
                        calendar &&
                        calendar.map((availability, i) => {
                          return (
                            <Field
                              component={FormCalendarCardSelect}
                              key={i}
                              name="date"
                              props={{
                                availability: availability.availability,
                                date: availability.date,
                                availabilityMessage: '',
                                style: 'blue',
                                fieldValue: availability.date,
                              }}
                            />
                          );
                        })}
                    </FormCalendar>
                  </FormCol>
                  <FormActions back={this.props.previousPage}>
                    <Button type="submit" buttonText="Continuar" disabled={!date} />
                  </FormActions>
                </form>
              </FormContent>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

ShiftSelect = reduxForm({
  form: 'shiftRequest',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(ShiftSelect);

const selector = formValueSelector('shiftRequest');

ShiftSelect = connect(state => {
  return {
    vehicle: selector(state, 'vehicle'),
    engine: selector(state, 'engine'),
    transmission: selector(state, 'transmission'),
    traction: selector(state, 'traction'),
    services: selector(state, 'services'),
    is_under_warranty: selector(state, 'is_under_warranty'),
    date: selector(state, 'date'),
    workshop: selector(state, 'workshop'),
  };
})(ShiftSelect);

const mapStateToProps = state => {
  return {
    calendar: state.models.calendar,
    isFetching: state.models.isFetching,
    brandId: state.configuration.brand_id,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchCalendar: (attributes, brandId) => {
      dispatch(fetchCalendar(attributes, brandId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShiftSelect);
